"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigService = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const core_shared_2 = require("@ikegps/core-shared");
const index_1 = require("./index");
class ConfigService {
    constructor() {
        this.__priority = 5;
    }
    get config() {
        if (this._config) {
            return this._config;
        }
        this.env = index_1.Services.Window.window.IKE_ENVIRONMENT;
        const configFromWindow = index_1.Services.Window.window.IKE_CONFIG;
        this._config = new core_shared_1.IkeConfig('office', this.env, configFromWindow);
        this._config.set('application.name', 'IkeOffice');
        this._config.set('application.url', '');
        switch (this._config.env) {
            case core_api_1.IkeEnvironment.PRODUCTION:
                this._config.set('som.url', 'https://span-o-matic.ikegps.com');
                break;
            case core_api_1.IkeEnvironment.STAGING:
                this._config.set('som.url', 'https://staging-span-o-matic.ikegps.net');
                break;
            case core_api_1.IkeEnvironment.TEST:
            case core_api_1.IkeEnvironment.TEST2:
            case core_api_1.IkeEnvironment.AUTOMATION:
            case core_api_1.IkeEnvironment.DEV:
                this._config.set('som.url', 'https://test-span-o-matic.ikegps.net');
                break;
            default:
                this._config.set('som.url', 'http://localhost:1234');
        }
        this._config.set('application.version', index_1.Services.Window.window.IKE_APPLICATION_VERSION);
        core_shared_2.IkeConfigStore.fetch = (a, b) => window.fetch(a, b);
        return this._config;
    }
}
exports.ConfigService = ConfigService;
//# sourceMappingURL=config.service.js.map